import { NAVIGATION_LINK_DATA_IN_TABLES } from '../../config/content-links'
import { toGeoSearch, toMapSearch, toTablesPage } from '../../../links'
import { defaultPanoramaUrl } from '../../../pages/MapPage/config'
import { routing as routes } from '../../../routes'
import Icon from '../Icon/Icon'
import Table from '../../assets/icons/list.svg'
import Map from '../../assets/icons/map.svg'
import Data from '../../assets/icons/data.svg'
import Pano from '../../assets/icons/pano.svg'

interface LocationDescriptorObject {
  pathname?: string | undefined
  search?: string | undefined
}
export interface NavigationLink {
  id: number
  to: LocationDescriptorObject
  CardIcon?: () => JSX.Element
  testId: string
  title: string
  description?: string
}

// The id's also represent the order in which they are displayed in the NavigationBlock on the homepage
// The order of how the items are placed in the array, is the order for the Menu
const navigationLinks: NavigationLink[] = [
  {
    id: 0,
    to: toGeoSearch(),
    CardIcon: () => (
      <Icon size={48}>
        <Map />
      </Icon>
    ),
    testId: 'Kaart',
    title: 'Kaart',
    description: 'Zoek en bekijk data op de kaart',
  },
  {
    id: 1,
    to: defaultPanoramaUrl,
    CardIcon: () => (
      <Icon size={48}>
        <Pano />
      </Icon>
    ),
    testId: 'Panoramabeelden',
    title: 'Panoramabeelden',
    description: 'Kijk 360 graden in het rond',
  },
  {
    id: 4,
    to: toTablesPage(),
    CardIcon: () => (
      <Icon size={42}>
        <Table />
      </Icon>
    ),
    testId: NAVIGATION_LINK_DATA_IN_TABLES.testId,
    title: NAVIGATION_LINK_DATA_IN_TABLES.title,
    description: NAVIGATION_LINK_DATA_IN_TABLES.description,
  },
  {
    id: 5,
    to: { pathname: routes.catalogOverview.path },
    CardIcon: () => (
      <Icon size={48}>
        <Data />
      </Icon>
    ),
    testId: routes.catalogOverview.title,
    title: routes.catalogOverview.title,
    description: 'Een overzicht van beschikbare datasets vanuit de Gemeente Amsterdam',
  },
  {
    id: 9,
    to: toMapSearch(),
    testId: routes.mapSearch.title,
    title: routes.mapSearch.title,
  },
]

export default navigationLinks
